<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  name: "HomeMainBlock",
  data() {
    return {};
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    let mm = gsap.matchMedia();
    // const timeline = gsap.timeline();
    mm.add("(min-width: 10px)", () => {
      gsap.set(".image", { y: "100%" });
      gsap.set(".image .abs", { scale: 0, opacity: 0 });
      gsap.set(".paths", { strokeDasharray: "0 1000" });
      gsap.set(".face", { scale: 0, opacity: 0 });
      let paths = document.querySelectorAll(".paths");
      // Анимация для каждого path с интервалом 0.3 сек
      paths.forEach((path, i) => {
        gsap.to(path, {
          strokeDasharray: "1000 0", // Анимация появления
          strokeDashoffset: 0, // Направление анимации
          duration: 0.4, // Длительность анимации
          delay: 2 + i * 0.4, // Задержка для каждого path
          ease: "power1.inOut",
        });
      });
      let faces = document.querySelectorAll(".face");
      faces.forEach((face, i) => {
        gsap.to(face, {
          scale: 1.1,
          opacity: 1,
          duration: 0.2,
          delay: 2.4 + i * 0.4,
          ease: "power1.inOut",
        })
        gsap.to(face, {
          scale: 1.0,
          opacity: 1,
          duration: 0.2,
          delay: 2.6 + i * 0.4,
          ease: "power1.inOut",
        })
      })

      gsap.to(".image", {
        y: "-15%",
        delay: 0.5,
        duration: 0.2,
      });
      gsap.to(".image", { y: "0%", delay: 0.7, duration: 0.2 });
      gsap.to(".abs.left", { scale: 1.1, opacity: 1, delay: 1, duration: 0.2 });
      gsap.to(".abs.left", { scale: 1, opacity: 1, delay: 1.2, duration: 0.2 });
      gsap.to(".abs.right", {
        scale: 1.1,
        opacity: 1,
        delay: 1.5,
        duration: 0.2,
      });
      gsap.to(".abs.right", {
        scale: 1,
        opacity: 1,
        delay: 1.7,
        duration: 0.2,
      });
    });
  },
};
</script>
<template>
  <div class="main">
    <div class="container">
      <div class="main__content">
        <div class="logo">
          <svg width="219" height="63" viewBox="0 0 219 63" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M31.4925 62.985C14.0743 62.985 0 48.8607 0 31.4925C0 14.0743 14.1242 0 31.4925 0C48.9106 0 62.9849 14.1242 62.9849 31.4925C63.0348 48.9106 48.9106 62.985 31.4925 62.985Z"
              fill="#7700FF" />
            <path d="M34.3361 34.4873H28.6465V44.1696H34.3361V34.4873Z" fill="white" />
            <path d="M49.966 18.7566L28.6152 40.1074L32.6384 44.1305L53.9891 22.7798L49.966 18.7566Z" fill="white" />
            <path d="M54.0501 38.4795H28.6465V44.1691H54.0501V38.4795Z" fill="white" />
            <path d="M30.3586 18.8113L9.00781 40.1621L13.0309 44.1852L34.3817 22.8345L30.3586 18.8113Z" fill="white" />
            <path d="M34.3372 18.8154H8.93359V24.505H34.3372V18.8154Z" fill="white" />
            <path d="M34.3381 18.7656H28.6484V28.448H34.3381V18.7656Z" fill="white" />
            <path
              d="M92.4317 15.4709C88.7884 15.4709 86.9417 16.1197 86.9417 17.4174C86.9417 18.0163 87.2412 18.4155 87.7902 18.715C88.3392 18.9645 89.3374 19.1642 90.7847 19.264L95.7257 19.5634C98.7203 19.813 100.916 20.362 102.264 21.2603C103.611 22.1587 104.31 23.4563 104.31 25.253C104.31 27.3492 103.312 28.9962 101.316 30.1441C99.3191 31.292 96.3745 31.841 92.5316 31.841C88.9381 31.841 86.1931 31.3419 84.3465 30.3937C82.4999 29.3955 81.302 27.8483 80.7031 25.6523L86.1931 24.8538C86.4426 25.9019 87.0915 26.7004 88.0897 27.1995C89.0878 27.6986 90.5352 27.9481 92.3818 27.9481C96.4743 27.9481 98.5705 27.2494 98.5705 25.9019C98.5705 25.253 98.321 24.8039 97.772 24.5543C97.223 24.3048 96.3246 24.1051 94.9271 23.9554L89.9363 23.656C86.9916 23.4563 84.7957 22.8574 83.3982 21.9092C82.0008 20.9609 81.3021 19.6133 81.3021 17.8665C81.3021 15.9201 82.2503 14.3729 84.1967 13.2749C86.1432 12.1769 88.8383 11.6279 92.3319 11.6279C95.7756 11.6279 98.4208 12.127 100.317 13.0753C102.164 14.0236 103.362 15.5208 103.861 17.4673L98.4208 18.2658C98.2211 17.3175 97.6222 16.6188 96.674 16.1696C95.7257 15.7205 94.3282 15.4709 92.4317 15.4709Z"
              fill="#7700FF" />
            <path
              d="M120.38 31.8909C116.338 31.8909 113.144 30.9926 110.898 29.1958C108.602 27.3991 107.504 24.9037 107.504 21.7594C107.504 18.6152 108.652 16.1197 110.898 14.323C113.193 12.5263 116.338 11.6279 120.38 11.6279C124.423 11.6279 127.617 12.5263 129.863 14.323C132.109 16.1197 133.257 18.6152 133.257 21.7594C133.257 24.9536 132.109 27.449 129.863 29.2457C127.617 30.9926 124.473 31.8909 120.38 31.8909ZM120.38 27.449C125.022 27.449 127.318 25.5525 127.318 21.7594C127.318 17.9663 125.022 16.0698 120.38 16.0698C115.739 16.0698 113.443 17.9663 113.443 21.7594C113.443 25.5525 115.739 27.449 120.38 27.449Z"
              fill="#1A1A1A" />
            <path
              d="M143.288 31.4922H138.098V4.79102H143.937V15.3218C144.935 14.124 146.183 13.2256 147.73 12.5768C149.277 11.928 150.974 11.5786 152.871 11.5786C156.215 11.5786 158.91 12.477 160.856 14.3236C162.803 16.1702 163.801 18.6158 163.801 21.7101C163.801 24.8045 162.803 27.2999 160.856 29.0966C158.91 30.9433 156.215 31.8416 152.871 31.8416C150.874 31.8416 149.128 31.4922 147.53 30.7935C145.933 30.0948 144.636 29.0966 143.638 27.8489L143.288 31.4922ZM151.074 27.3498C153.32 27.3498 155.017 26.8507 156.165 25.9025C157.313 24.9043 157.912 23.5567 157.912 21.76C157.912 19.9633 157.313 18.5659 156.165 17.6176C155.017 16.6693 153.32 16.1203 151.074 16.1203C148.828 16.1203 147.081 16.6194 145.834 17.6176C144.586 18.6158 143.937 20.0132 143.937 21.76C143.937 23.5068 144.586 24.9043 145.834 25.9025C147.081 26.8507 148.828 27.3498 151.074 27.3498Z"
              fill="#1A1A1A" />
            <path
              d="M180.22 31.8909C176.178 31.8909 173.034 30.9926 170.688 29.1459C168.392 27.3492 167.244 24.8538 167.244 21.7095C167.244 18.6651 168.392 16.2195 170.688 14.3729C172.984 12.5263 176.128 11.6279 180.121 11.6279C182.666 11.6279 184.862 12.0272 186.758 12.7758C188.655 13.5245 190.102 14.6724 191.15 16.1197C192.199 17.5671 192.698 19.264 192.698 21.2104C192.698 21.8592 192.598 22.5081 192.448 23.2068H173.034C173.583 26.2013 175.978 27.6986 180.22 27.6986C184.014 27.6986 186.21 26.8002 186.858 24.9536L192.498 25.9518C191.849 27.998 190.502 29.4953 188.555 30.4935C186.609 31.3918 183.864 31.8909 180.22 31.8909ZM180.171 15.7704C176.228 15.7704 173.882 17.068 173.183 19.7132H186.958C186.359 17.068 184.063 15.7704 180.171 15.7704Z"
              fill="#1A1A1A" />
            <path
              d="M207.121 15.4709C203.478 15.4709 201.631 16.1197 201.631 17.4174C201.631 18.0163 201.931 18.4155 202.48 18.715C203.029 18.9645 204.027 19.1642 205.474 19.264L210.415 19.5634C213.41 19.813 215.606 20.362 216.953 21.2603C218.301 22.1587 218.999 23.4563 218.999 25.253C218.999 27.3492 218.001 28.9962 216.005 30.1441C214.009 31.292 211.064 31.841 207.221 31.841C203.628 31.841 200.883 31.3419 199.036 30.3937C197.189 29.3955 195.991 27.8483 195.393 25.6523L200.883 24.8538C201.132 25.9019 201.781 26.7004 202.779 27.1995C203.777 27.6986 205.225 27.9481 207.071 27.9481C211.164 27.9481 213.26 27.2494 213.26 25.9019C213.26 25.253 213.01 24.8039 212.461 24.5543C211.912 24.3048 211.014 24.1051 209.617 23.9554L204.626 23.656C201.681 23.4563 199.485 22.8574 198.088 21.9092C196.69 20.9609 195.991 19.6133 195.991 17.8665C195.991 15.9201 196.94 14.3729 198.886 13.2749C200.833 12.1769 203.528 11.6279 207.021 11.6279C210.465 11.6279 213.11 12.127 215.007 13.0753C216.853 14.0236 218.051 15.5208 218.55 17.4673L213.11 18.2658C212.911 17.3175 212.312 16.6188 211.363 16.1696C210.465 15.7205 209.018 15.4709 207.121 15.4709Z"
              fill="#1A1A1A" />
            <path d="M81.502 46.9641V45.916H87.4411V46.9641H85.0455V52.1546H83.8975V46.9641H81.502Z" fill="#1A1A1A" />
            <path
              d="M89.9369 54.8501H88.7891V45.9164H89.9369V46.5653C90.436 46.0163 91.1348 45.7168 92.0331 45.7168C93.0313 45.7168 93.7799 46.0163 94.3289 46.6651C94.8779 47.3139 95.1774 48.0625 95.1774 48.9609C95.1774 49.8592 94.8779 50.6578 94.3289 51.2567C93.7799 51.9055 92.9814 52.2049 92.0331 52.2049C91.1348 52.2049 90.436 51.9055 89.9369 51.3565V54.8501ZM90.5359 47.4137C90.1366 47.813 89.9369 48.3121 89.9369 49.0607C89.9369 49.7594 90.1366 50.3084 90.5359 50.7077C90.9351 51.107 91.4342 51.2567 92.0331 51.2567C92.632 51.2567 93.0812 51.057 93.4805 50.6079C93.8798 50.1587 94.0295 49.6596 94.0295 49.0607C94.0295 48.4618 93.8299 47.9128 93.4805 47.5135C93.1311 47.1143 92.632 46.8647 92.0331 46.8647C91.4342 46.8148 90.9351 47.0144 90.5359 47.4137Z"
              fill="#1A1A1A" />
            <path
              d="M99.4194 45.7666C100.318 45.7666 101.017 45.9662 101.566 46.4154C102.115 46.8646 102.364 47.4136 102.364 48.2121V52.1549H101.216V51.5061C100.717 52.0551 99.9684 52.3545 99.0701 52.3545C98.3215 52.3545 97.7226 52.1549 97.2235 51.8056C96.7743 51.4562 96.5248 50.9571 96.5248 50.2584C96.5248 49.5597 96.7743 49.0606 97.2734 48.7112C97.7725 48.4118 98.4213 48.2121 99.2198 48.2121H101.166C101.166 47.2638 100.567 46.8147 99.3695 46.8147C98.9703 46.8147 98.6209 46.9145 98.3215 47.0642C98.022 47.2139 97.7724 47.4635 97.6726 47.713H96.375C96.5247 47.1141 96.924 46.6151 97.473 46.2657C98.022 45.9163 98.6708 45.7666 99.4194 45.7666ZM101.216 49.6595V49.2602H99.2697C98.2217 49.2602 97.7226 49.6096 97.7226 50.2584C97.7226 50.9072 98.2217 51.2566 99.2198 51.2566C99.8187 51.2566 100.318 51.1068 100.717 50.8074C101.017 50.5079 101.216 50.1087 101.216 49.6595Z"
              fill="#1A1A1A" />
            <path
              d="M109.201 45.916H110.349V52.1047H109.201V49.5095H105.558V52.1047H104.41V45.916H105.558V48.4614H109.201V45.916Z"
              fill="#1A1A1A" />
            <path
              d="M118.235 47.7132H116.987C116.637 47.1142 116.088 46.8148 115.34 46.8148C114.741 46.8148 114.242 47.0144 113.843 47.4636C113.443 47.8629 113.244 48.4119 113.244 49.0108C113.244 49.6596 113.443 50.1587 113.843 50.558C114.242 50.9572 114.741 51.2068 115.34 51.2068C116.088 51.2068 116.637 50.9073 116.987 50.3084H118.235C117.985 50.9073 117.636 51.4064 117.136 51.7558C116.637 52.1051 116.039 52.3048 115.34 52.3048C114.441 52.3048 113.643 52.0053 113.044 51.3565C112.445 50.7576 112.096 49.9591 112.096 49.0108C112.096 48.0625 112.395 47.3139 113.044 46.6651C113.643 46.0662 114.441 45.7168 115.34 45.7168C116.039 45.7168 116.637 45.9165 117.136 46.2658C117.636 46.6651 118.035 47.1142 118.235 47.7132Z"
              fill="#1A1A1A" />
            <path
              d="M123.426 43.1211H124.574V45.916H125.173C126.121 45.916 126.92 46.2155 127.519 46.8144C128.118 47.4133 128.467 48.112 128.467 49.0104C128.467 49.9586 128.167 50.7073 127.569 51.2563C126.97 51.8053 126.171 52.1047 125.173 52.1047H124.574V54.8497H123.426V52.1047H122.827C121.779 52.1047 120.981 51.8053 120.432 51.2563C119.833 50.7073 119.533 49.9586 119.533 49.0104C119.533 48.112 119.833 47.3634 120.481 46.8144C121.08 46.2155 121.879 45.916 122.827 45.916H123.426V43.1211ZM123.426 46.9641H122.827C122.178 46.9641 121.629 47.1637 121.23 47.563C120.831 47.9623 120.631 48.4614 120.631 49.0603C120.631 49.6592 120.831 50.1583 121.18 50.5575C121.53 50.9568 122.079 51.1564 122.777 51.1564H123.376V46.9641H123.426ZM125.173 46.9641H124.574V51.1065H125.173C125.872 51.1065 126.421 50.9069 126.77 50.5076C127.119 50.1084 127.319 49.6093 127.319 49.0104C127.319 48.4115 127.119 47.9124 126.72 47.5131C126.371 47.1637 125.822 46.9641 125.173 46.9641Z"
              fill="#1A1A1A" />
            <path
              d="M133.059 51.2069C133.807 51.2069 134.356 50.9074 134.706 50.3584H135.953C135.754 50.9573 135.354 51.4065 134.855 51.7559C134.356 52.1052 133.757 52.255 133.059 52.255C132.11 52.255 131.362 51.9555 130.713 51.3067C130.114 50.7078 129.814 49.9092 129.814 48.961C129.814 48.0127 130.114 47.2641 130.713 46.6152C131.312 45.9664 132.06 45.667 133.009 45.667C133.857 45.667 134.606 45.9664 135.205 46.5653C135.804 47.1643 136.053 47.9129 136.053 48.8112C136.053 49.0608 136.053 49.2604 136.003 49.3103H131.012C131.062 49.8094 131.312 50.2586 131.711 50.5581C132.11 51.0571 132.559 51.2069 133.059 51.2069ZM133.009 46.8149C132.46 46.8149 132.06 46.9646 131.661 47.2641C131.312 47.5635 131.112 47.9628 131.012 48.4619H134.805C134.755 47.9628 134.556 47.5635 134.206 47.2641C133.907 46.9646 133.508 46.8149 133.009 46.8149Z"
              fill="#1A1A1A" />
            <path
              d="M138.947 54.8501H137.799V45.9164H138.947V46.5653C139.446 46.0163 140.145 45.7168 141.043 45.7168C142.041 45.7168 142.79 46.0163 143.339 46.6651C143.888 47.3139 144.187 48.0625 144.187 48.9609C144.187 49.8592 143.888 50.6578 143.339 51.2567C142.79 51.9055 141.991 52.2049 141.043 52.2049C140.145 52.2049 139.446 51.9055 138.947 51.3565V54.8501ZM139.546 47.4137C139.146 47.813 138.947 48.3121 138.947 49.0607C138.947 49.7594 139.146 50.3084 139.546 50.7077C139.945 51.107 140.444 51.2567 141.043 51.2567C141.642 51.2567 142.091 51.057 142.49 50.6079C142.89 50.1587 143.039 49.6596 143.039 49.0607C143.039 48.4618 142.84 47.9128 142.49 47.5135C142.141 47.1143 141.642 46.8647 141.043 46.8647C140.444 46.8148 139.945 47.0144 139.546 47.4137Z"
              fill="#1A1A1A" />
            <path
              d="M152.273 48.0122L150.277 52.1047H149.129L147.132 48.0122V52.1047H145.984V45.916H147.282L149.728 50.9069L152.173 45.916H153.471V52.1047H152.323V48.0122H152.273Z"
              fill="#1A1A1A" />
            <path
              d="M158.062 45.7666C158.96 45.7666 159.659 45.9662 160.208 46.4154C160.757 46.8646 161.007 47.4136 161.007 48.2121V52.1549H159.859V51.5061C159.36 52.0551 158.611 52.3545 157.713 52.3545C156.964 52.3545 156.365 52.1549 155.866 51.8056C155.417 51.4562 155.167 50.9571 155.167 50.2584C155.167 49.5597 155.417 49.0606 155.916 48.7112C156.415 48.4118 157.064 48.2121 157.862 48.2121H159.809C159.809 47.2638 159.21 46.8147 158.012 46.8147C157.613 46.8147 157.263 46.9145 156.964 47.0642C156.665 47.2139 156.415 47.4635 156.315 47.713H155.018C155.167 47.1141 155.567 46.6151 156.116 46.2657C156.715 45.9163 157.363 45.7666 158.062 45.7666ZM159.859 49.6595V49.2602H157.912C156.864 49.2602 156.365 49.6096 156.365 50.2584C156.365 50.9072 156.864 51.2566 157.862 51.2566C158.461 51.2566 158.96 51.1068 159.36 50.8074C159.709 50.5079 159.859 50.1087 159.859 49.6595Z"
              fill="#1A1A1A" />
            <path
              d="M164.201 54.8501H163.053V45.9164H164.201V46.5653C164.7 46.0163 165.398 45.7168 166.297 45.7168C167.295 45.7168 168.044 46.0163 168.593 46.6651C169.142 47.3139 169.441 48.0625 169.441 48.9609C169.441 49.8592 169.142 50.6578 168.593 51.2567C168.044 51.9055 167.245 52.2049 166.297 52.2049C165.398 52.2049 164.7 51.9055 164.201 51.3565V54.8501ZM164.8 47.4137C164.4 47.813 164.201 48.3121 164.201 49.0607C164.201 49.7594 164.4 50.3084 164.8 50.7077C165.199 51.107 165.698 51.2567 166.297 51.2567C166.896 51.2567 167.345 51.057 167.744 50.6079C168.143 50.1587 168.293 49.6596 168.293 49.0607C168.293 48.4618 168.094 47.9128 167.744 47.5135C167.395 47.1143 166.896 46.8647 166.297 46.8647C165.698 46.8148 165.199 47.0144 164.8 47.4137Z"
              fill="#1A1A1A" />
            <path
              d="M171.188 45.916H172.335V48.6111L175.33 45.916H176.877L173.433 49.0104L176.877 52.1047H175.33L172.335 49.5594V52.1047H171.188V45.916Z"
              fill="#1A1A1A" />
            <path
              d="M180.82 51.2069C181.569 51.2069 182.118 50.9074 182.467 50.3584H183.715C183.515 50.9573 183.116 51.4065 182.617 51.7559C182.118 52.1052 181.519 52.255 180.82 52.255C179.872 52.255 179.123 51.9555 178.474 51.3067C177.876 50.7078 177.576 49.9092 177.576 48.961C177.576 48.0127 177.876 47.2641 178.474 46.6152C179.073 45.9664 179.822 45.667 180.77 45.667C181.619 45.667 182.367 45.9664 182.966 46.5653C183.565 47.1643 183.815 47.9129 183.815 48.8112C183.815 49.0608 183.815 49.2604 183.765 49.3103H178.774C178.824 49.8094 179.073 50.2586 179.473 50.5581C179.822 51.0571 180.271 51.2069 180.82 51.2069ZM180.72 46.8149C180.171 46.8149 179.772 46.9646 179.373 47.2641C179.024 47.5635 178.824 47.9628 178.724 48.4619H182.517C182.467 47.9628 182.268 47.5635 181.918 47.2641C181.669 46.9646 181.219 46.8149 180.72 46.8149Z"
              fill="#1A1A1A" />
            <path d="M184.564 46.9641V45.916H190.504V46.9641H188.108V52.1546H186.96V46.9641H184.564Z" fill="#1A1A1A" />
          </svg>

        </div>
        <div class="head">
          <h1 class="head-h1">
            Новая эпоха в поиске <br />
            квалифицированных членов команды
          </h1>
        </div>
        <div class="image">
          <img class="mobile desk" src="@/assets/image/mobile.png" alt="image" />
          <img class="mobile mob" src="@/assets/image/mobile-mob.png" alt="image" />
          <img class="abs right" src="@/assets/image/mesRight.png" alt="image" />
          <img class="abs left" src="@/assets/image/mesLeft.png" alt="image" />
        </div>
        <div class="konture abs">
          <div class="konture__images">
            <svg class="vectorLine desk" width="1267" height="359" viewBox="0 0 1267 359" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path class="onePath paths" d="M35 1C82.4229 132.306 223 288.5 527 318.435" stroke="#B2BEC4"
                stroke-width="2" stroke-linecap="round" stroke-dasharray="11 11" />
              <path class="fivePath paths" d="M1.74338 230C-3.40433 186.222 15.8402 85.9322 134 35" stroke="#B2BEC4"
                stroke-width="2" stroke-linecap="round" stroke-dasharray="11 11" />
              <path class="twoPath paths" d="M7 315C268.5 361 958 394 1254 281.5" stroke="#B2BEC4" stroke-width="2"
                stroke-linecap="round" stroke-dasharray="11 11" />
              <path class="threePath paths" d="M1264.86 21.3258C1270.54 78.6933 1242.72 209.333 1086 272.953"
                stroke="#B2BEC4" stroke-width="2" stroke-linecap="round" stroke-dasharray="11 11" />
              <path class="fourPath paths" d="M855.106 205.922C877.439 197.013 958.5 216 976.628 248.505"
                stroke="#B2BEC4" stroke-width="2" stroke-linecap="round" stroke-dasharray="11 11" />
            </svg>
            <svg class="vectorLine mob" width="363" height="355" viewBox="0 0 363 355" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path  class="onePath paths"
                d="M100 15.2801C154.76 -11.551 276.058 -4.48586 319.94 70.383C363.823 145.252 377.222 243.795 341.556 354"
                stroke="#B2BEC3" stroke-width="2" stroke-linecap="round" stroke-dasharray="7 7" />
              <path class="fivePath paths" d="M30.4473 65.2571C17.5042 84.6916 10.4326 118.981 36.4806 162.328" stroke="#B2BEC4"
                stroke-width="2" stroke-linecap="round" stroke-dasharray="7 7" />
              <path class="twoPath paths" d="M86 180.976C115.553 177.65 154.766 156.421 175.644 95.4902" stroke="#B2BEC4" stroke-width="2"
                stroke-linecap="round" stroke-dasharray="7 7" />
              <path class="threePath paths" d="M302.521 36.5366C280.637 47.5049 256.142 76.0077 256.501 132.348" stroke="#B2BEC4"
                stroke-width="2" stroke-linecap="round" stroke-dasharray="7 7" />
            </svg>
            <img src="@/assets/image/1Face.png" alt="" class="face abs face1">
            <img src="@/assets/image/2Face.png" alt="" class="face abs face2">
            <img src="@/assets/image/3Face.svg" alt="" class="face abs face3">
            <img src="@/assets/image/4Face.png" alt="" class="face abs face4">
            <img src="@/assets/image/5Face.png" alt="" class="face abs face5">
            <img src="@/assets/image/6Face.svg" alt="" class="face abs face6">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.main__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-radius: 100px;
  background: #e7ecee;
  overflow: hidden;
  position: relative;
}

.logo {
  width: 219px;
  margin-top: 46px;
}

.logo svg {
  width: 100%;
}

.head {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
}

.head-h1 {
  color: #1a1a1a;
  text-align: center;
  font-family: Aeroport;
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
  line-height: 86%;
  letter-spacing: -3px;
}

.image {
  position: relative;
  display: flex;
  z-index: 2;
}

.mobile {
  position: relative;
  z-index: 1;
}

.mobile.mob {
  display: none;
}

.abs {
  position: absolute;
}

.right {
  top: 2px;
  right: -80%;
  z-index: 0;
}

.left {
  top: 70px;
  left: -80%;
}

.konture {
  width: 78%;
  bottom: 25px;
  left: 7.28%;
  z-index: 0;
}

.vectorLine {
  width: 100%;
}
.vectorLine.mob {
  display: none;
}
.konture__images {
  position: relative;
  width: 100%;
  height: 100%;
}

.face1 {
  top: calc(-100px - 21px);
  left: -25px;
}

.face2 {
  top: -26px;
  left: 11.69%;
}

.face3 {
  left: -16px;
  bottom: 75px;
}

.face4 {
  right: -111.6px;
  bottom: 82px;
}

.face5 {
  right: 15.57%;
  bottom: 42.69px;
}

.face6 {
  right: -158.86px;
  top: -53px;
}

@media (max-width: 991px) {
  .head-h1 {
    font-size: 40px;
    line-height: 120%;
  }
}

@media (max-width: 650px) {
  .main__content {
    border-radius: 40px;
  }

  .logo {
    width: 149px;
    margin-top: 45px;
  }

  .mobile.desk {
    display: none;
  }
  .mobile.mob {
    display: block;
  }
  .vectorLine.desk {
    display: none;
  }
  .vectorLine.mob {
    display: block;
  }
  .head-h1 {
    font-size: 32px;
    line-height: 120%;
  }
  .head {
    margin: 0 auto 223px;
    max-width: 303px;
  }
  .left {
    width: 238px;
    top: 60px;
    left: -80%;
    max-width: max-content;
  }
  .right {
    top: -45px;
    right: -80%;
    z-index: 0;
    width: 200px;
    max-width: max-content;
  }
  .konture {
    width: 100%;
    bottom: 129px;
    left: 0;
  }
  .konture__images {
    max-width: 363px;
    margin: 0 auto;
  }
  .face6 {
    right: 8%;
    top: 39%;
    width: 91px;
  }
  .face5 {
    right: 4%;
    bottom: auto;
    top: 0%;
    width: 43px;
  }
  .face2 {
    top: 12%;
    left: 45%;
    width: 43px;
  }
  .face3 {
    left: 4%;
    bottom: auto;
    width: 108px;
    top: 5%;
  }
  .face1 {
    top: 47%;
    left: 6%;
    width: 55px;
  }
  .face4 {
    right: 1%;
    bottom: -20%;
    width: 65px;
  }
}
</style>